import { render, staticRenderFns } from "./ProgressVcDemo.vue?vue&type=template&id=2f208328&scoped=true&"
import script from "./ProgressVcDemo.vue?vue&type=script&lang=js&"
export * from "./ProgressVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./ProgressVcDemo.vue?vue&type=style&index=0&id=2f208328&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f208328",
  null
  
)

export default component.exports